<kzn-sign-drag-resize [isCustomTagElement]="true" [onRemoveElement]="destroyComponent"
    [isCustomTagElementStatic]="isCustomTagElementStatic">
    <ng-container tag-content>
        @switch (tag) {
        @case (EnumSignTagTypes.DATE) {
        <mat-form-field appearance="outline" [class]="'sign-tag-field-wrapper ' + (className || '')" data-type="DATE">
            <mat-label>{{ label || 'Date' }}</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="dateObject" (dateChange)="onDateChange($event.value)"
                [attr.data-value-available]="!!tagValue" [attr.data-value]="tagValue" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        }
        @case (EnumSignTagTypes.CHECKBOX) {
        <div class="sign-tag-checkbox-row" data-type="CHECKBOX">
            <mat-checkbox color="primary" [class]="className" [(ngModel)]="checkboxChecked"
                (ngModelChange)="onCheckboxCheckedChange($event)"
                [attr.data-value-available]="checkboxChecked"
                [attr.data-value]="checkboxChecked ? 'true' : ''"></mat-checkbox>
            <input type="text" class="sign-tag-checkbox-label self-sign-tag-field__checkbox-label"
                [(ngModel)]="checkboxLabelText" [attr.data-value]="checkboxLabelText"
                [placeholder]="label || 'Check to confirm'"
                (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()" />
        </div>
        } @case (EnumSignTagTypes.INITIALS) {
        <mat-form-field appearance="outline" [class]="'sign-tag-field-wrapper ' + (className || '')" data-type="INITIALS">
            <mat-label>{{label || 'Initials'}}</mat-label>
            <input matInput [(ngModel)]="tagValue" [attr.data-value-available]="!!tagValue"
                [attr.data-value]="tagValue">
        </mat-form-field>
        } @case (EnumSignTagTypes.TEXT) {
        <mat-form-field appearance="outline" [class]="'sign-tag-field-wrapper ' + (className || '')" data-type="TEXT">
            <mat-label>{{label || 'Text'}}</mat-label>
            <input matInput [(ngModel)]="tagValue" [attr.data-value-available]="!!tagValue"
                [attr.data-value]="tagValue">
        </mat-form-field>
        } @case (EnumSignTagTypes.STAMP) {
        <div [class]="className + 'custom-tag__stamp-container'" data-type="STAMP">
            @if(stamp) {
            <img
              class="custom-tag__stamp-image"
              [src]="stamp"
              data-value-available="true"
              alt=""
              (click)="stampRef.click()" />
            } @else {
            <button mat-button mat-raised-button (click)="stampRef.click()">
                {{label || 'Select file'}}
            </button>
            }
        </div>
        <input #stampRef hidden type="file" accept="image/png, image/jpeg, image/jpg"
            (change)="onFileSelected($event)" />
        }
        }
    </ng-container>
</kzn-sign-drag-resize>